import React from 'react'
import { ApiClientImplementation } from 'infra/api-client/api-client'
import { PrepareApiRequestDecorator } from 'main/decorators/prepare-api-request-decorator/prepare-api-request-decorator'
import { makeLocalStorageAdapter } from 'main/factories/cache/local-storage-adapter-factory'
import { ApiRepository } from 'repository/api-repository'
import { DoctorRepository } from 'repository/repositories/doctor/doctor-repository'
import { RemoteLoadDoctor } from 'service/usecases/load-doctor/remote-load-doctor'
import Signature from 'presentation/doctor/pages/Signature'

export default function makeDoctorSignature() {
  const apiClient = new ApiClientImplementation()
  const apiRepository = new PrepareApiRequestDecorator(
    makeLocalStorageAdapter(),
    new ApiRepository(apiClient)
  )

  const doctorRepository = new DoctorRepository(apiRepository)
  const loadDoctor = new RemoteLoadDoctor(doctorRepository)

  return <Signature loadDoctor={loadDoctor} />
}
